// extracted by mini-css-extract-plugin
export default {"root":"PropertyDetails__root--wYhyb"};